import React from 'react'
import Globals from '../Globals'
import Verification from '../assets/img/marca-de-verificacao.png'
function InputImageNoChange({ image, imageAvatar, verification }) {

    return (
        <div style={{ position: 'relative', maxHeight: '200px' }}>
            {
                verification === 1 ? <img style={{left:5, top:20}} className='verified-icon' src={Verification} /> : <></>
            }
            {
                image.fileReal === '' ? image.file === null || image.file === "" ? <div className="image-client" > <img width={'100%'} alt='avatar' src={imageAvatar} /> </div> : <div className="image-client" style={{ backgroundImage: 'url(' + Globals.BASE_URL + '/storage/' + image.file + ')' }}></div> : <div className="image-client" style={{ backgroundImage: 'url(' + image.file + ')' }}></div>
            }
        </div>
    )
}

export default InputImageNoChange;